module.exports = __webpack_public_path__ + "media/bootstrap-icons/bag-fill-62f4fbc7.svg";